import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_MONITOR_CREATE,
    ACTION_MONITOR_LOAD,
    ACTION_MONITOR_LOAD_BY_ID,

    ACTION_MONITOR_SAVE,
    ACTION_MONITOR_VALIDATE,
    ACTION_MONITORS_LOAD_BY_MONITORING_ID,
    CreateFailure,
    CreateSuccess,
    IMonitorCreateAction,
    IMonitorCreateFailureAction,
    IMonitorCreateSuccessAction,
    IMonitorLoadAction,
    IMonitorLoadByIdAction,
    IMonitorLoadFailureAction,
    IMonitorLoadSuccessAction,

    IMonitorSaveAction,
    IMonitorSaveFailureAction,
    IMonitorSaveSuccessAction,
    IMonitorValidateAction,
    IMonitorValidateFailureAction,
    IMonitorValidateSuccessAction,
    IMonitorsLoadByMonitoringIdAction,
    LoadFailure,
    LoadSuccess,
    SaveFailure,
    SaveSuccess,
    ValidateFailure,
    ValidateSuccess,
} from "../actions/monitor";
import { monitorsApi } from "../services/monitors";

export const
    getMonitorsEpic = (action$): Observable<IMonitorLoadSuccessAction | IMonitorLoadFailureAction> => {
        return action$
            .ofType(ACTION_MONITOR_LOAD)
            .mergeMap((_action: IMonitorLoadAction) => {
                return monitorsApi
                    .getMonitors()
                    .map(response =>
                        LoadSuccess(response.monitors, undefined, [], response.lookups, undefined)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getMonitorsByMonitoringIdEpic = (action$): Observable<IMonitorLoadSuccessAction | IMonitorLoadFailureAction> => {
        return action$
            .ofType(ACTION_MONITORS_LOAD_BY_MONITORING_ID)
            .mergeMap((action: IMonitorsLoadByMonitoringIdAction) => {
                return monitorsApi
                    .getMonitorsByMonitoringId(action.monitoringId)
                    .map(response =>
                        LoadSuccess(response.monitors, null, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getMonitorsByIdEpic = (action$): Observable<IMonitorLoadSuccessAction | IMonitorLoadFailureAction> => {
        return action$
            .ofType(ACTION_MONITOR_LOAD_BY_ID)
            .mergeMap((action: IMonitorLoadByIdAction) => {
                return monitorsApi
                    .getMonitorById(action.id)
                    .map(response =>
                        LoadSuccess(response.monitor, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setMonitorEpic = (action$): Observable<IMonitorSaveSuccessAction | IMonitorSaveFailureAction> => {
        return action$
            .ofType(ACTION_MONITOR_SAVE)
            .mergeMap((action: IMonitorSaveAction) => {
                return monitorsApi
                    .setMonitor(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.monitor, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createMonitorEpic = (action$): Observable<IMonitorCreateSuccessAction | IMonitorCreateFailureAction> => {
        return action$
            .ofType(ACTION_MONITOR_CREATE)
            .mergeMap((action: IMonitorCreateAction) => {
                return monitorsApi
                    .createMonitor(action.monitoringId)
                    .map(response =>
                        CreateSuccess(response.monitor, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateMonitorEpic = (action$): Observable<IMonitorValidateSuccessAction | IMonitorValidateFailureAction> => {
        return action$
            .ofType(ACTION_MONITOR_VALIDATE)
            .mergeMap((action: IMonitorValidateAction) => {
                return monitorsApi
                    .validateMonitor(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.monitor, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }